import type { FC } from "react";
import { useWatch } from "react-hook-form";
import { DESCRIPTION_MAX_LENGTH, type PlaybookFormValues } from "./playbook-editor.types";

export const DescriptionCharCount: FC = () => {
  const description = useWatch<PlaybookFormValues, "description">({ name: "description" });
  const length = description?.length ?? 0;
  const isOver = length > DESCRIPTION_MAX_LENGTH;

  return (
    <p
      aria-live="polite"
      className={`text-sm text-end ${isOver ? "text-destructive font-medium" : "text-muted-foreground"}`}
    >
      {length} / {DESCRIPTION_MAX_LENGTH}
    </p>
  );
};
